import axios, { AxiosResponse } from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

/**
 * Fetches and downloads tool spec as a json file
 * @param toolVersionId
 */
export const downloadToolSpec = async (
  toolVersionId: number,
): Promise<void> => {
  const headers = await getRequestHeaders();

  const res = await axios.get<undefined, AxiosResponse<unknown>>(
    getEnvVar("URL_TRS_TOOL_VERSION_DOWNLOAD_TOOL_SPEC")(toolVersionId),
    { headers },
  );
  const jsonData = JSON.stringify(res.data);

  const blob = new Blob([jsonData], { type: "application/json" });

  const downloadUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", "parameters.json");

  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(downloadUrl);
  document.body.removeChild(link);
};
